import { useTranslation } from 'react-i18next';
import ErisSummaryTable from './ErisStatusSummaryTable';
import useGroupService from 'src/api/eris/service/ErisInformationService';
import useDisasterService from 'src/api/eris/service/ErisDisasterService';
import Win95Button from '../../../common/button/Win95Button';
import { useErisInformationStore } from 'src/api/eris/store/ErisInformationStore';

const ErisStatusSummaryComponent = () => {
  const { t } = useTranslation();
  const { prepareGroupSummaryCsvDownload } = useGroupService();
  const { getLatestDisaster } = useDisasterService();
  const { statusSummaryList } = useErisInformationStore();
  const groupCount = (statusSummaryList?.groupSummaries ?? []).length;
  const summaryCount = groupCount * Number(groupCount > 0);

  const handleDownload = async () => {
    try {
      const { blob, filename } = await prepareGroupSummaryCsvDownload();
      if (blob) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error('Download failed', err);
    }
    getLatestDisaster();
  };

  return (
    <div className="space-y-4 py-4">
      <h3 className="text-xl font-bold">{t('eris.supportSummaryList.title')}</h3>
      <div>
        {t('eris.supportSummaryList.subTitle', {
          number: summaryCount,
        })}
      </div>

      <ErisSummaryTable />

      <div className="flex justify-end">
        <Win95Button
          title={t('eris.common.csvDownload')}
          onClick={handleDownload}
          disabled={false}
        />
      </div>
    </div>
  );
};

export default ErisStatusSummaryComponent;
